<template lang="pug">
main
  PmHeader
  .container
    br
    article.message.is-info
      .message-header
        p Información de la Suscripción
      .message-body
        .p
          strong Suscriptor:
          | {{ ' ' + tracks.suscriptor }}
        .p
          strong Organización:
          | {{ ' ' + tracks.organizacion }}
        .p
          strong Formato de Fechas:
          | {{ ' ' + tracks.formatoFecha }}
        .p
          strong Fecha de Expiración:
          | {{ ' ' + tracks.fechaFinal }}
        .p
          strong La suscripción caducará en:
          | {{ ' ' + tracks.diasRestantes + ' ' }}
          strong días
        br
        a.button.is-info(@click="actualizar") Actualizar    
      br
    .modal(v-bind:class="{'is-active':isLoading}")
      .modal-background
      .modal-card
        header.modal-card-head
          p 
            strong Actualizando
        section.modal-card-body
            progress.progress.is-small.is-primary(max='100') 15%
        footer.modal-card-foot
</template>
<script>
import trackService from '@/services/track'

import PmHeader from '../components/layout/Header.vue'

export default {
  components: {
    PmHeader
  },

  data: () => ({
    tracks: '',
    isLoading: false
  }),

  mounted() {
    if (localStorage.getItem('token')) {
      this.usuario = JSON.parse(localStorage.getItem('usuario'))
    } else {
      this.$router.push('/')
    }    
  },

  methods: {
    getDatosSuscripcion () {
      this.isLoading = true
      trackService.suscripcion()
        .then(res => {
          // console.log(res)
          this.tracks = res
          this.isLoading = false
        })
    },
    actualizar () {
      this.isLoading = true
      trackService.suscripcionActualizar()
        .then(res => {
          this.tracks = res
          this.isLoading = false
        })      
    }
  },

  beforeMount () {
    this.getDatosSuscripcion()
  }
}
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  justify-content: left;
}
</style>
